import scrollLock from 'scroll-lock';
import throttle from 'lodash.throttle';
import { ScrollTrigger } from 'gsap/all';
import gsap from 'gsap';
export default class ModuleMenu {
    constructor() {
        this.menuwrapper = document.querySelector('[data-module-menu]');
        if (!this.menuwrapper) {
            return;
        }

        this.menuActive = false;

        this.menuTargets = [];
        this.menuLinks = this.menuwrapper.querySelectorAll('[data-module-link]');
        this.menuListItems = this.menuwrapper.querySelectorAll('[data-module-target]');

        this.menuLinks.forEach((link) => {
            this.menuTargets.push(link.getAttribute('href'));
            link.addEventListener('click', (e) => {
                e.preventDefault();
                const offset = window.matchMedia('(min-width: 768px)').matches ? 113 : 0;

                gsap.to(window, {
                    duration: 0.5,
                    scrollTo: {
                        y: link.getAttribute('href'),
                        offsetY: offset,
                    },
                });
            });
        });

        this.menuTargets.forEach((target) => {
            const element = document.querySelector(target);
            ScrollTrigger.create({
                trigger: element,
                start: 'top 115px',
                end: 'bottom',
                onEnter: () => {
                    this.menuListItems.forEach((listItem) => {
                        listItem.classList.remove('is-active');
                        if (listItem.dataset.moduleTarget === target) {
                            listItem.classList.add('is-active');
                        }
                    });
                },
                onEnterBack: () => {
                    this.menuListItems.forEach((listItem) => {
                        listItem.classList.remove('is-active');
                        if (listItem.dataset.moduleTarget === target) {
                            listItem.classList.add('is-active');
                        }
                    });
                },
            });
        });

        this.isActive = false;
        this.toggleMenuButtons = document.querySelectorAll('[data-toggle-module-menu]');
        this.toggleMenuButtons.forEach((button) => {
            button.addEventListener('click', this.handleToggleClick.bind(this));
        });

        this.mobileToggleButton = document.querySelector('[data-mobile-toggle-module-menu]');

        ScrollTrigger.create({
            trigger: 'body',
            start: 'top top',
            end: 'bottom bottom',
            onUpdate: (self) => {
                if (this.menuActive) {
                    return;
                }

                if (self.direction == -1) {
                    this.mobileToggleButton.classList.add('is-shown');
                } else {
                    this.mobileToggleButton.classList.remove('is-shown');
                }
            },
        });
    }

    showMenu() {
        if (window.matchMedia('(max-width:768px)').matches) {
            scrollLock.disablePageScroll(this.menuwrapper);
        }

        this.menuActive = true;

        this.menuwrapper.classList.add('c-module-menu--active');
        this.toggleMenuButtons.forEach((button) => {
            button.classList.add('is-active');
        });
    }

    hideMenu() {
        if (window.matchMedia('(max-width:768px)').matches) {
            scrollLock.enablePageScroll(this.menuwrapper);
        }

        this.menuActive = false;

        this.menuwrapper.classList.remove('c-module-menu--active');
        this.toggleMenuButtons.forEach((button) => {
            button.classList.remove('is-active');
        });
    }

    handleToggleClick() {
        this.isActive = !this.isActive;

        if (this.isActive) {
            this.showMenu();
        } else {
            this.hideMenu();
        }
    }
}